import { useAxiosPost } from './usePost';
import { RegistUserResponse } from '@project_bamboo/shared';

const useUpdatePoint = () => {
  return useAxiosPost<RegistUserResponse>('/users/update-point');
};

export default useUpdatePoint;
